import React, { Component } from 'react';
import { Platform, Animated } from 'react-native';

import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

const withDiscoverSnap = WrappedDashboard =>
  class WithDiscoverSnap extends Component {
    static propTypes = {
      getFlatListRef: PropTypes.func,
    };

    constructor() {
      super();
      this.flatListRef = React.createRef();
      this.discoverSectionRef = React.createRef();
      this.scrollY = new Animated.Value(0);
    }
    onTouchStart = () => {
      // reset flags
      this.snapping = false;
      this.scrollAnimating = false;
    };
    onMomentumScrollBegin = () => {
      // flag for telling that there is a scroll animating so that onScrollEndDrag shoudn't handle that case
      this.scrollAnimating = true;
    };

    onScrollEndDrag = async () => {
      // timeout to check if its scroll or drag as onMomentumScrollBegin will tell us before timeout if user has start scroll
      await this.timeout(50);
      if (!this.scrollAnimating) {
        this.checkIfHasScrolledEnoughFromDiscover();
      }
    };
    onMomentumScrollEnd = () => {
      if (this.snapping) {
        return;
      }
      this.checkIfHasScrolledEnoughFromDiscover();
    };
    onScroll = nativeEvent => {
      this.scrollY = nativeEvent.contentOffset.y;
    };
    timeout = ms => {
      return new Promise(resolve => setTimeout(resolve, ms));
    };
    checkIfHasScrolledEnoughFromDiscover = () => {
      if (this.discoverSectionRef?.measureInWindow) {
        this.discoverSectionRef.measureInWindow((x, y) => {
          if ((y < 0 && y >= -200) || (y > 0 && y <= 200)) {
            this.snapping = true;
            this.scrollToOffset(y);
          }
        });
      }
    };
    scrollToOffset = offset => {
      const currentScrollPos = this.scrollY;
      const margin = Platform.OS == 'android' ? 30 : 50;
      this.flatListRef?.scrollToOffset({
        offset: currentScrollPos + offset - margin,
        animated: true,
      });
    };

    setFlatListRef = ref => {
      const { getFlatListRef } = this.props;

      this.flatListRef = ref;

      if (_isFunction(getFlatListRef)) {
        getFlatListRef(ref);
      }
    };
    setDiscoverSectionRef = ref => {
      this.discoverSectionRef = ref;
    };
    render() {
      const withDiscoverSnapProps = {
        setFlatListRef: this.setFlatListRef,
        setDiscoverSectionRef: this.setDiscoverSectionRef,
        onScroll: this.onScroll,
        onTouchStart: this.onTouchStart,
        onMomentumScrollEnd: this.onMomentumScrollEnd,
        onMomentumScrollBegin: this.onMomentumScrollBegin,
        onScrollEndDrag: this.onScrollEndDrag,
      };
      return <WrappedDashboard withDiscoverSnapProps={withDiscoverSnapProps} {...this.props} />;
    }
  };

export default withDiscoverSnap;
